var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_45277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 9.99378V5.99641C1 5.73137 1.10529 5.47718 1.2927 5.28977C1.48011 5.10236 1.7343 4.99707 1.99934 4.99707H9.99408C10.2591 4.99707 10.5133 5.10236 10.7007 5.28977C10.8881 5.47718 10.9934 5.73137 10.9934 5.99641V9.99378",
    stroke: "#6A7282",
    strokeWidth: 0.999342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4.99705V2.99837C2 2.73332 2.10529 2.47914 2.2927 2.29172C2.48011 2.10431 2.7343 1.99902 2.99934 1.99902H8.99539C9.26043 1.99902 9.51462 2.10431 9.70203 2.29172C9.88945 2.47914 9.99473 2.73332 9.99473 2.99837V4.99705",
    stroke: "#6A7282",
    strokeWidth: 0.999342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 1.99902V4.99705",
    stroke: "#6A7282",
    strokeWidth: 0.999342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 8.99414H10.9934",
    stroke: "#6A7282",
    strokeWidth: 0.999342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_45277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9921,
    height: 11.9921,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.3c65f1f14604f1a09cb529b23803692f.svg";
export { ForwardRef as ReactComponent };